import doNothing from '@opsbase/lib-general/utils/doNothing';
import Vertical from '@opsbase/web-layout/Vertical';
import MenuItem from '@opsbase/web-ui/MenuItem';
import React from 'react';
function TemplateChooserList(props) {
    const { data = [], selected = [], onSelect = doNothing } = props;
    return (React.createElement(Vertical, { shrink: true, style: { overflow: 'auto', minWidth: '25%' } }, data.map((item, idx) => (React.createElement(MenuItem, { key: 'item' + idx, showChevron: true, variant: "small", selected: selected.indexOf(item.id) >= 0, onClick: () => onSelect(item.id), label: item.title })))));
}
export default TemplateChooserList;
